var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRouteStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6649 1.35156H5.03825C3.22494 1.35156 1.91154 2.40491 1.50488 4.07158C1.49154 4.1049 1.47819 4.13823 1.4716 4.17155L1.47144 4.17416L1.4716 4.17623C1.47176 4.17774 1.47192 4.17924 1.4716 4.18091V4.19157C1.3982 4.51156 1.35156 4.84489 1.35156 5.20492V10.4982C1.35156 12.8049 2.83154 14.3515 5.03825 14.3515H7.99189C7.60456 13.6719 7.38329 12.8854 7.38329 12.0472C7.38329 9.47314 9.47002 7.3864 12.0441 7.3864C12.8836 7.3864 13.6712 7.60834 14.3516 7.99674V5.20492C14.3516 2.89824 12.8716 1.35156 10.6649 1.35156Z",
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4972 13.7878C14.2734 13.5562 14.0463 13.3279 13.817 13.1019C13.7648 13.0501 13.7575 13.0136 13.7973 12.9466C14.0816 12.4655 14.1974 11.9469 14.1402 11.3872C14.0006 10.0159 12.75 9.00515 11.3943 9.17241C9.70889 9.37995 8.72475 11.1765 9.44669 12.728C9.91215 13.7286 11.0016 14.3022 12.08 14.1201C12.4274 14.0613 12.7459 13.9324 13.048 13.7415C13.2929 13.9897 13.5346 14.2351 13.7771 14.4801C13.812 14.5147 13.8496 14.5499 13.8912 14.5749C14.1114 14.7085 14.3828 14.6589 14.5384 14.4598C14.6982 14.2564 14.684 13.9809 14.4972 13.7878ZM11.7 13.1453C10.867 13.1472 10.2024 12.4853 10.2024 11.6534C10.2028 10.8335 10.8684 10.162 11.6804 10.162C12.4964 10.1624 13.1565 10.8275 13.1584 11.6511C13.1597 12.4733 12.5056 13.1435 11.7 13.1453Z",
    fill: "#1080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52993 5.93062L6.13664 13.3506H5.11662L6.54997 5.73063L2.36328 4.86398C2.39657 4.51063 2.46997 4.17729 2.5966 3.89062L7.23659 4.85063L13.3499 6.10397V7.13062L7.52993 5.93062Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouteStatus);
export default __webpack_public_path__ + "static/media/route_status.378f4e9ec84023e54836f19567bfa29e.svg";
export { ForwardRef as ReactComponent };